export default "__VITE_PUBLIC_ASSET__010321f5__"